export default __webpack_public_path__ + "static/media/1462.8f98f2dc.png";